import { IconBox, IconProps } from '@summer/jst-react-icon';

export const FDA = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props} viewBox="0 0 78 32">
    <g clipPath="url(#clip0_16673_82388)">
      <path
        d="M3.997 31.617H.477V.431h30.938c13.57 0 15.711 12.191 15.711 12.191L54.741.432h7.98l14.586 23.645-4.57 7.54H53.506v-3.762h21.512L58.722.43S47.983 19.117 45.678 22.758c-2.306 3.64-6.636 8.858-14.054 8.858H20.135V13.05h3.64v14.804h8.373c3.703 0 11.65-3.155 11.65-12.074 0-8.918-8.495-11.71-11.286-11.71H3.996V31.619Zm1.213 0V18.392H18.8v3.64H8.85v9.587H5.21ZM18.8 16.814v-3.762H8.85v-3.99h22.896c3.433 0 7.077 2.776 7.077 6.841s-3.684 6.856-6.31 6.856h-3.57v-9.707h-3.761V26.4h7.33c4.644 0 10.012-4.03 10.012-10.375 0-6.285-4.882-10.618-10.72-10.618H5.211v11.406H18.8Zm23.237 14.803L58.722 4.073 72.434 26.4H53.505v-3.64h12.256l-7.038-11.468-11.588 20.326H42.037Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_16673_82388">
        <path fill="currentColor" d="M0 0h77.643v32H0z" />
      </clipPath>
    </defs>
  </IconBox>
);
